import { CreateFlightBookingPaymentIntentState } from './createFlightBookingPaymentIntent.types'

const initialState: CreateFlightBookingPaymentIntentState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
